/**
 * Суммы в AZN для маркетингового фронта (лендинг, легал с плейсхолдерами).
 * Синхронизировано с `activitiesCatalogDisplayPrices` и опубликованными тарифами 2026.
 *
 * Потребители: `programContent`, `TangoFestivalProgramSection`, `RegistrationInfoModal`.
 */
import {
  DISPLAY_CHAMPIONSHIP_BAKU_AZN,
  DISPLAY_CHAMPIONSHIP_METROPOLITANGO_AZN,
  DISPLAY_MILONGA_COUPLE_STANDARD_AZN,
  DISPLAY_MILONGA_PASS_5_EVENINGS_AZN,
  DISPLAY_MILONGA_PASS_COUPLE_AZN,
  DISPLAY_MILONGA_SOLO_STANDARD_AZN,
  DISPLAY_WORKSHOP_GROUP_AZN,
  DISPLAY_WORKSHOP_PRIVATE_MAX_AZN,
  DISPLAY_WORKSHOP_PRIVATE_ORNELLA_AZN,
} from '@/config/activitiesCatalogDisplayPrices';

export const festivalLandingStaticPrices = {
  workshopGroupClass: DISPLAY_WORKSHOP_GROUP_AZN,

  workshopPrivateFrom: DISPLAY_WORKSHOP_PRIVATE_ORNELLA_AZN,
  workshopPrivateTo: DISPLAY_WORKSHOP_PRIVATE_MAX_AZN,

  milongaSingleTicket: DISPLAY_MILONGA_SOLO_STANDARD_AZN,
  milongaCoupleTicket: DISPLAY_MILONGA_COUPLE_STANDARD_AZN,

  milongaPass5Evenings: DISPLAY_MILONGA_PASS_5_EVENINGS_AZN,
  milongaPassCouple: DISPLAY_MILONGA_PASS_COUPLE_AZN,

  concertOpening: 74,
  concertClosing: 74,

  registrationChampionshipMetropolitangoNational:
    DISPLAY_CHAMPIONSHIP_METROPOLITANGO_AZN.national,
  registrationChampionshipMetropolitangoInternational:
    DISPLAY_CHAMPIONSHIP_METROPOLITANGO_AZN.international,
  registrationChampionshipBakuTrophy: DISPLAY_CHAMPIONSHIP_BAKU_AZN.price,
} as const;

export type FestivalLandingStaticPriceKey = keyof typeof festivalLandingStaticPrices;
